
Vue.component("linechart", {
	extends: VueChartJs.Line,
	props: ['data','options'],
	mounted() {
		this.renderChart(this.data,this.options);
	},
	methods : {
	},
    watch: {
        data: function() {
        	if(this.data.labels.length > 0){
                this.$data._chart.update();
                this.renderChart(this.data,this.options);
			}
        },
        // options:function(){
        //     this.$data._chart.update();
        //     this.renderChart(this.data,this.options);
		//
		// }
    }

});
